export { default } from './es/icons/ArrowLeftOutlined';